import { render } from "./CongratulationModal.vue?vue&type=template&id=6834577c"
import script from "./CongratulationModal.vue?vue&type=script&lang=js"
export * from "./CongratulationModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/coastal-watchers-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__